<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Nueva Compra" />

    <div class="flex-grow-1 overflow-auto px-3 pb-5">

      <!-- Selector de modo -->
      <div class="d-flex gap-2 mb-3 align-items-center">
        <span class="small text-muted me-1">Modo:</span>
        <button class="btn btn-sm btn-secondary" disabled>
          Sistema Anterior
        </button>
        <button class="btn btn-sm btn-outline-primary" @click="$router.push('/importar-xml')">
          Sistema Nuevo <span class="beta-badge">Beta</span>
        </button>
      </div>

      <!-- Formulario manual (sistema anterior) -->
      <div>

        <!-- Cabecera del documento -->
        <div class="card mb-3">
          <div class="card-body">
            <h6 class="card-title mb-3">Datos de la factura</h6>
            <div class="row g-2">
              <div class="col-md-4">
                <label class="form-label small fw-semibold mb-1">Proveedor <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input v-model="busquedaProveedor" type="text"
                    class="form-control form-control-sm"
                    :class="cab.idorigen ? 'border-success' : ''"
                    placeholder="Buscar por nombre o RUC…"
                    @input="onBuscarProveedor"
                    @blur="onBlurProveedor" />
                  <ul v-if="sugerenciasProveedor.length"
                    class="list-group position-absolute w-100 shadow-sm"
                    style="z-index:200;top:100%;max-height:200px;overflow-y:auto">
                    <li v-for="p in sugerenciasProveedor" :key="p.idpersona"
                      class="list-group-item list-group-item-action py-1 px-2 small"
                      style="cursor:pointer"
                      @mousedown.prevent="seleccionarProveedor(p)">
                      <span class="fw-semibold">{{ p.razonsocial }}</span>
                      <span class="text-muted ms-2">{{ p.nrodoc }}</span>
                    </li>
                  </ul>
                </div>
                <div v-if="cab.idorigen" class="form-text text-success mt-1">
                  ✓ {{ cab.nombreProveedor }}
                </div>
              </div>
              <div class="col-md-1">
                <label class="form-label small fw-semibold mb-1">Tipo Doc.</label>
                <select v-model="cab.idtipodoc" class="form-select form-select-sm">
                  <option :value="2">Factura</option>
                  <option :value="1">Boleta</option>
                  <option :value="3">Guía de remisión</option>
                </select>
              </div>
              <div class="col-md-1">
                <label class="form-label small fw-semibold mb-1">Serie</label>
                <input v-model="cab.serie" type="text" class="form-control form-control-sm"
                  placeholder="F001" maxlength="10" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Número</label>
                <input v-model="cab.numero" type="text" class="form-control form-control-sm"
                  placeholder="00001234" maxlength="20" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Fecha de emisión</label>
                <input v-model="cab.fecha_emision" type="date" class="form-control form-control-sm" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Fecha de recepción</label>
                <input v-model="cab.fecha_recep" type="date" class="form-control form-control-sm" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Almacén</label>
                <select v-model="cab.idalmacen" class="form-select form-select-sm">
                  <option :value="1">Lapoint 939</option>
                  <option :value="15">Lapoint 1179</option>
                </select>
              </div>
              <div class="col-md-1">
                <label class="form-label small fw-semibold mb-1">Moneda</label>
                <select v-model="cab.moneda" class="form-select form-select-sm">
                  <option value="PEN">S/</option>
                  <option value="USD">$</option>
                </select>
              </div>
              <div class="col-md-1" v-if="cab.moneda === 'USD'">
                <label class="form-label small fw-semibold mb-1">T. Cambio</label>
                <input v-model.number="cab.tipo_camb" type="number" min="1" step="0.01"
                  class="form-control form-control-sm" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">IGV (%)</label>
                <div class="d-flex align-items-center gap-2">
                  <input v-model.number="cab.igv" type="number" min="0" max="30"
                    class="form-control form-control-sm" style="width:70px" />
                  <div class="form-check form-switch mb-0">
                    <input v-model="cab.con_igv" class="form-check-input" type="checkbox" id="swConIgv" />
                    <label class="form-check-label small" for="swConIgv">c/IGV</label>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Observación</label>
                <input v-model="cab.observacion" type="text" class="form-control form-control-sm"
                  placeholder="Opcional" maxlength="500" />
              </div>
            </div>
          </div>
        </div>

        <!-- Buscador de productos -->
        <div class="card mb-3">
          <div class="card-body py-2">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <div class="position-relative flex-grow-1" style="max-width:420px">
                <input ref="inputBuscarProd" v-model="busquedaProducto" type="text"
                  class="form-control form-control-sm"
                  placeholder="Escanea barcode o escribe código de proveedor…"
                  @keyup.enter="buscarProducto"
                  @input="onInputProducto" />
                <ul v-if="sugerenciasProd.length"
                  class="list-group position-absolute w-100 shadow"
                  style="z-index:200;top:100%;max-height:260px;overflow-y:auto">
                  <li v-for="p in sugerenciasProd" :key="p.idpres"
                    class="list-group-item list-group-item-action py-1 px-2 small"
                    style="cursor:pointer"
                    @mousedown.prevent="agregarDesdeResultado(p)">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <span class="badge bg-light text-dark border me-1" style="font-size:10px">{{ p.talla }}</span>
                        <span class="fw-semibold">{{ p.producto }}</span>
                      </div>
                      <code class="text-muted" style="font-size:10px">{{ p.codbarras }}</code>
                    </div>
                    <div class="text-muted" style="font-size:10px">{{ p.codigo_prov }} · S/ {{ fmt(p.precvta) }}</div>
                  </li>
                </ul>
              </div>
              <button class="btn btn-sm btn-outline-primary" @click="buscarProducto" :disabled="buscandoProd">
                <span v-if="buscandoProd" class="spinner-border spinner-border-sm"></span>
                <span v-else>Buscar</span>
              </button>
              <span v-if="errorBusqueda" class="text-danger small">{{ errorBusqueda }}</span>
              <button v-if="mostrarBotonNuevo" class="btn btn-sm btn-warning" @click="abrirFormNuevo">
                + Producto nuevo
              </button>
            </div>
          </div>
        </div>

        <!-- Formulario de alta de producto nuevo -->
        <div v-if="formNuevo.visible" class="card mb-3 border-warning">
          <div class="card-header py-2 bg-warning bg-opacity-10 d-flex justify-content-between align-items-center">
            <span class="fw-semibold small">Registrar producto nuevo</span>
            <button class="btn btn-xs btn-outline-secondary py-0 px-2 small" @click="cerrarFormNuevo">✕ Cancelar</button>
          </div>
          <div class="card-body">
            <div class="row g-2">
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Tipo <span class="text-danger">*</span></label>
                <select v-model="formNuevo.idsuperlinea" class="form-select form-select-sm"
                  @change="formNuevo.idlinea = null">
                  <option :value="1">CALZADO</option>
                  <option :value="2">TEXTIL</option>
                  <option :value="3">ACCESORIOS</option>
                  <option :value="4">OTROS</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Línea <span class="text-danger">*</span></label>
                <select v-model="formNuevo.idlinea" class="form-select form-select-sm">
                  <option :value="null" disabled>Seleccionar…</option>
                  <option v-for="l in lineasFiltradas" :key="l.idlinea" :value="l.idlinea">
                    {{ l.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Marca <span class="text-danger">*</span></label>
                <select v-model="formNuevo.idgrupo" class="form-select form-select-sm">
                  <option :value="null" disabled>Seleccionar…</option>
                  <option v-for="g in catalogos.grupos" :key="g.idgrupo" :value="g.idgrupo">
                    {{ g.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Género <span class="text-danger">*</span></label>
                <select v-model="formNuevo.idtalla" class="form-select form-select-sm">
                  <option :value="null" disabled>Seleccionar…</option>
                  <option v-for="t in catalogos.tallas" :key="t.idtalla" :value="t.idtalla">
                    {{ t.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label small fw-semibold mb-1">Nombre del producto <span class="text-danger">*</span></label>
                <input v-model="formNuevo.nombre" type="text" class="form-control form-control-sm"
                  placeholder="Ej: ZAPATILLA ULTRABOOST 22" maxlength="200" />
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Código proveedor <span class="text-danger">*</span></label>
                <input v-model="formNuevo.codigo_prov" type="text" class="form-control form-control-sm"
                  placeholder="Ej: GX5462" maxlength="50" />
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-semibold mb-1">Código de barras</label>
                <input v-model="formNuevo.codbarras" type="text" class="form-control form-control-sm"
                  :placeholder="busquedaProducto || 'Escanear o escribir'" maxlength="50" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Talla USA <span class="text-danger">*</span></label>
                <input v-model="formNuevo.talla_usa" type="text" class="form-control form-control-sm"
                  placeholder="Ej: 10.5" maxlength="15" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Talla Perú</label>
                <input v-model="formNuevo.talla_peru" type="text" class="form-control form-control-sm"
                  placeholder="Ej: 44" maxlength="10" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Precio venta (S/)</label>
                <input v-model.number="formNuevo.precvta" type="number" min="0" step="0.01"
                  class="form-control form-control-sm" placeholder="0.00" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Precio compra (S/) <span class="text-danger">*</span></label>
                <input v-model.number="formNuevo.precio" type="number" min="0" step="0.01"
                  class="form-control form-control-sm" placeholder="0.00" />
              </div>
              <div class="col-md-2">
                <label class="form-label small fw-semibold mb-1">Cantidad <span class="text-danger">*</span></label>
                <input v-model.number="formNuevo.cantidad" type="number" min="1"
                  class="form-control form-control-sm" />
              </div>
            </div>
            <div v-if="errorFormNuevo" class="alert alert-danger mt-2 py-1 small">{{ errorFormNuevo }}</div>
            <div class="mt-3">
              <button class="btn btn-sm btn-warning fw-semibold" @click="agregarProductoNuevo">
                Agregar a la compra
              </button>
            </div>
          </div>
        </div>

        <!-- Tabla de items -->
        <div class="card mb-3">
          <div class="card-header py-2 d-flex justify-content-between align-items-center">
            <span class="small fw-semibold">Líneas de la compra</span>
            <span class="small text-muted">{{ items.length }} productos · {{ totalUnidades }} unidades</span>
          </div>
          <div class="card-body p-0">
            <div v-if="!items.length" class="text-center text-muted py-4 small">
              Busca un producto arriba para agregarlo
            </div>
            <div v-else class="table-responsive">
              <table class="table table-sm mb-0 align-middle" style="font-size:13px">
                <thead class="table-light">
                  <tr>
                    <th class="ps-3">Producto</th>
                    <th class="text-center" style="width:70px">Talla</th>
                    <th style="width:110px">Barcode</th>
                    <th class="text-center" style="width:80px">Cantidad</th>
                    <th class="text-end" style="width:110px">P. Compra (S/)</th>
                    <th class="text-end" style="width:100px">Subtotal</th>
                    <th style="width:36px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(it, i) in items" :key="i">
                    <td class="ps-3">
                      <div class="d-flex align-items-center gap-1">
                        <span v-if="it.nuevo" class="badge bg-warning text-dark" style="font-size:9px">NUEVO</span>
                        <span class="fw-semibold" style="font-size:12px">{{ it.producto }}</span>
                      </div>
                      <div class="text-muted" style="font-size:11px">{{ it.codigo_prov }}</div>
                    </td>
                    <td class="text-center">
                      <span class="badge bg-light text-dark border">{{ it.talla }}</span>
                    </td>
                    <td>
                      <code class="small text-muted">{{ it.codbarras || '—' }}</code>
                    </td>
                    <td class="text-center">
                      <input v-model.number="it.cantidad" type="number" min="1"
                        class="form-control form-control-sm text-center p-1"
                        style="width:60px;font-size:12px" />
                    </td>
                    <td class="text-end">
                      <input v-model.number="it.precio" type="number" min="0" step="0.01"
                        class="form-control form-control-sm text-end p-1"
                        style="width:90px;font-size:12px" />
                    </td>
                    <td class="text-end fw-semibold small">
                      S/ {{ fmt(it.cantidad * it.precio) }}
                    </td>
                    <td>
                      <button class="btn btn-xs btn-outline-danger p-0 px-1" @click="quitarItem(i)" title="Quitar">✕</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Totales -->
        <div v-if="items.length" class="card mb-3">
          <div class="card-body py-2">
            <div class="row justify-content-end">
              <div class="col-md-3">
                <table class="table table-sm mb-0" style="font-size:13px">
                  <tr>
                    <td class="text-muted">Subtotal (sin IGV)</td>
                    <td class="text-end fw-semibold">S/ {{ fmt(subtotal) }}</td>
                  </tr>
                  <tr>
                    <td class="text-muted">IGV ({{ cab.igv }}%)</td>
                    <td class="text-end">S/ {{ fmt(valorIgv) }}</td>
                  </tr>
                  <tr class="table-light">
                    <td class="fw-bold">Total</td>
                    <td class="text-end fw-bold text-primary fs-6">S/ {{ fmt(totalDoc) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="errorRegistro" class="alert alert-danger">{{ errorRegistro }}</div>

      </div>

    </div>

    <!-- Barra inferior fija -->
    <div style="position:sticky;bottom:0;z-index:10;background:#fff;border-top:1px solid #dee2e6;padding:10px 16px"
      class="d-flex justify-content-between align-items-center">
      <div class="small text-muted">
        <span v-if="items.length">{{ items.length }} productos · {{ totalUnidades }} unidades · Total S/ {{ fmt(totalDoc) }}</span>
        <span v-else>Sin productos agregados</span>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/purchase-list')">Cancelar</button>
        <button class="btn btn-sm btn-success"
          :disabled="registrando || !puedeGuardar"
          @click="registrar">
          <span v-if="registrando" class="spinner-border spinner-border-sm me-1"></span>
          {{ registrando ? 'Guardando…' : (cab.idtipodoc === 3 ? 'Registrar guía' : 'Registrar compra') }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import MainHeader from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import api from '../../services/api';

export default {
  name: 'NuevaCompraPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu },

  data() {
    const hoy = new Date().toISOString().slice(0, 10);
    return {
      cab: {
        idalmacen: 1,
        idtipodoc: 2,
        serie: '',
        numero: '',
        fecha_emision: hoy,
        fecha_recep: hoy,
        idorigen: null,
        nombreProveedor: '',
        moneda: 'PEN',
        tipo_camb: 3.8,
        igv: 18,
        con_igv: false,
        observacion: '',
      },

      busquedaProveedor: '',
      sugerenciasProveedor: [],
      proveedorTimer: null,

      busquedaProducto: '',
      sugerenciasProd: [],
      buscandoProd: false,
      errorBusqueda: null,
      prodTimer: null,
      mostrarBotonNuevo: false,

      formNuevo: {
        visible: false,
        idsuperlinea: 1,
        idlinea: null,
        idgrupo: null,
        idtalla: null,
        nombre: '',
        codigo_prov: '',
        codbarras: '',
        talla_usa: '',
        talla_peru: '',
        precvta: 0,
        precio: 0,
        cantidad: 1,
      },
      errorFormNuevo: null,

      catalogos: {
        lineas: [],
        grupos: [],
        tallas: [],
      },

      items: [],
      registrando: false,
      errorRegistro: null,
    };
  },

  computed: {
    lineasFiltradas() {
      return this.catalogos.lineas.filter(l => l.idsuperlinea === this.formNuevo.idsuperlinea);
    },
    subtotal() {
      const bruto = this.items.reduce((s, i) => s + i.cantidad * i.precio, 0);
      if (this.cab.con_igv) return bruto / (1 + this.cab.igv / 100);
      return bruto;
    },
    valorIgv() {
      return this.subtotal * (this.cab.igv / 100);
    },
    totalDoc() {
      return this.subtotal + this.valorIgv;
    },
    totalUnidades() {
      return this.items.reduce((s, i) => s + (i.cantidad || 0), 0);
    },
    puedeGuardar() {
      return this.cab.idorigen && this.cab.serie && this.cab.numero &&
        this.cab.fecha_emision && this.cab.fecha_recep && this.items.length > 0;
    },
  },

  async mounted() {
    try {
      const [rLineas, rGrupos, rTallas] = await Promise.all([
        api.get('/catalogo/lineas'),
        api.get('/catalogo/grupos'),
        api.get('/catalogo/tallas'),
      ]);
      this.catalogos.lineas = rLineas.data?.data  || rLineas.data  || [];
      this.catalogos.grupos = rGrupos.data?.data  || rGrupos.data  || [];
      this.catalogos.tallas = rTallas.data?.data  || rTallas.data  || [];
    } catch { /* catalogos no críticos */ }
  },

  methods: {
    fmt(v) {
      return Number(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    // ── Proveedor ──────────────────────────────────────────────────────────
    onBuscarProveedor() {
      this.cab.idorigen = null;
      clearTimeout(this.proveedorTimer);
      if (this.busquedaProveedor.length < 2) { this.sugerenciasProveedor = []; return; }
      this.proveedorTimer = setTimeout(async () => {
        try {
          const r = await api.get('/proveedores', { params: { q: this.busquedaProveedor, limit: 10 } });
          this.sugerenciasProveedor = r.data?.data?.data || r.data?.data || [];
        } catch { this.sugerenciasProveedor = []; }
      }, 300);
    },
    onBlurProveedor() {
      setTimeout(() => { this.sugerenciasProveedor = []; }, 150);
    },
    seleccionarProveedor(p) {
      this.cab.idorigen = p.idpersona;
      this.cab.nombreProveedor = p.razonsocial;
      this.busquedaProveedor = p.razonsocial;
      this.sugerenciasProveedor = [];
    },

    // ── Producto ───────────────────────────────────────────────────────────
    onInputProducto() {
      clearTimeout(this.prodTimer);
      this.errorBusqueda = null;
      this.mostrarBotonNuevo = false;
      if (this.busquedaProducto.length < 2) { this.sugerenciasProd = []; return; }
      this.prodTimer = setTimeout(() => this.buscarProducto(), 400);
    },
    async buscarProducto() {
      if (!this.busquedaProducto.trim()) return;
      this.buscandoProd = true;
      this.errorBusqueda = null;
      this.sugerenciasProd = [];
      this.mostrarBotonNuevo = false;
      try {
        const r = await api.get('/productos/buscar', {
          params: { q: this.busquedaProducto.trim(), limit: 20 },
        });
        const lista = r.data?.data || [];
        if (!lista.length) {
          this.errorBusqueda = 'No encontrado en el catálogo.';
          this.mostrarBotonNuevo = true;
        } else if (lista.length === 1) {
          this.agregarDesdeResultado(lista[0]);
        } else {
          this.sugerenciasProd = lista;
        }
      } catch (e) {
        this.errorBusqueda = e.response?.data?.error || 'Error al buscar';
      } finally {
        this.buscandoProd = false;
      }
    },
    agregarDesdeResultado(prod) {
      this.sugerenciasProd = [];
      this.busquedaProducto = '';
      this.errorBusqueda = null;
      this.mostrarBotonNuevo = false;
      const existente = this.items.find(i => i.idpres === prod.idpres);
      if (existente) { existente.cantidad++; return; }
      this.items.push({
        idpres:      prod.idpres,
        idprod:      prod.idprod,
        producto:    prod.producto,
        talla:       prod.talla,
        codbarras:   prod.codbarras,
        codigo_prov: prod.codigo_prov,
        cantidad:    1,
        precio:      prod.precvta || 0,
        afecto:      true,
        tipoprod:    1,
        nuevo:       false,
      });
      this.$nextTick(() => this.$refs.inputBuscarProd?.focus());
    },
    quitarItem(i) {
      this.items.splice(i, 1);
    },
    recalcular() { /* los totales se calculan via computed */ },

    // ── Formulario producto nuevo ──────────────────────────────────────────
    abrirFormNuevo() {
      this.formNuevo.visible = true;
      this.formNuevo.codbarras = this.busquedaProducto.trim();
      this.errorFormNuevo = null;
    },
    cerrarFormNuevo() {
      this.formNuevo.visible = false;
      this.errorFormNuevo = null;
    },
    agregarProductoNuevo() {
      this.errorFormNuevo = null;
      const f = this.formNuevo;
      if (!f.idlinea)                    { this.errorFormNuevo = 'Selecciona una línea'; return; }
      if (!f.idgrupo)                    { this.errorFormNuevo = 'Selecciona una marca'; return; }
      if (f.idtalla === null)            { this.errorFormNuevo = 'Selecciona el género'; return; }
      if (!f.nombre.trim())              { this.errorFormNuevo = 'Ingresa el nombre del producto'; return; }
      if (!f.codigo_prov.trim())         { this.errorFormNuevo = 'Ingresa el código del proveedor'; return; }
      if (!f.talla_usa.trim())           { this.errorFormNuevo = 'Ingresa la talla USA'; return; }
      if (!f.precio)                     { this.errorFormNuevo = 'Ingresa el precio de compra'; return; }
      if (!f.cantidad || f.cantidad < 1) { this.errorFormNuevo = 'Cantidad debe ser mayor a 0'; return; }

      this.items.push({
        nuevo:        true,
        idpres:       null,
        idsuperlinea: f.idsuperlinea,
        idlinea:      f.idlinea,
        idgrupo:      f.idgrupo,
        idtalla:      f.idtalla,
        nombre:       f.nombre.trim().toUpperCase(),
        codigo_prov:  f.codigo_prov.trim().toUpperCase(),
        codbarras:    f.codbarras.trim(),
        talla_usa:    f.talla_usa.trim(),
        talla_peru:   f.talla_peru.trim(),
        precvta:      f.precvta || 0,
        producto:     f.nombre.trim().toUpperCase(),
        talla:        f.talla_usa.trim(),
        cantidad:     f.cantidad,
        precio:       f.precio,
        afecto:       true,
        tipoprod:     1,
      });

      // mantiene nombre/marca/línea para agregar la siguiente talla fácilmente
      Object.assign(this.formNuevo, {
        codbarras: '', talla_usa: '', talla_peru: '', precio: f.precio, cantidad: 1,
      });
      this.errorFormNuevo = null;
    },

    // ── Registrar ──────────────────────────────────────────────────────────
    async registrar() {
      this.registrando = true;
      this.errorRegistro = null;
      try {
        const payload = {
          idalmacen:    this.cab.idalmacen,
          idorigen:     this.cab.idorigen,
          idtipodoc:    this.cab.idtipodoc,
          serie:        this.cab.serie.trim(),
          numero:       this.cab.numero.trim(),
          fecha_emision: this.cab.fecha_emision,
          fecha_recep:  this.cab.fecha_recep,
          moneda:       this.cab.moneda,
          tipo_camb:    this.cab.tipo_camb || 1,
          igv:          this.cab.igv,
          con_igv:      this.cab.con_igv,
          valor_igv:    parseFloat(this.valorIgv.toFixed(2)),
          montototdoc:  parseFloat(this.totalDoc.toFixed(2)),
          observacion:  this.cab.observacion || '',
          actualizastock: true,
          crear_cta_pagar: this.cab.idtipodoc !== 3,
          tipo_documento_abrev: this.cab.idtipodoc === 2 ? 'FAC' : this.cab.idtipodoc === 1 ? 'BOL' : 'GR',
          items: this.items.map(i => {
            const base = {
              idpres:            i.idpres,
              cantidad:          i.cantidad,
              precio:            i.precio,
              afecto:            i.afecto !== false,
              tipoprod:          i.tipoprod || 1,
              porcdescuento:     0,
              preciounitcondesc: i.precio,
              neto:              parseFloat((i.precio / (this.cab.con_igv ? (1 + this.cab.igv / 100) : 1)).toFixed(4)),
            };
            if (i.nuevo) {
              return {
                ...base,
                nuevo:        true,
                idsuperlinea: i.idsuperlinea,
                idlinea:      i.idlinea,
                idgrupo:      i.idgrupo,
                idtalla:      i.idtalla,
                nombre:       i.nombre,
                codigo_prov:  i.codigo_prov,
                codbarras:    i.codbarras,
                talla_usa:    i.talla_usa,
                talla_peru:   i.talla_peru,
                precvta:      i.precvta,
              };
            }
            return base;
          }),
        };
        await api.post(this.cab.idtipodoc === 3 ? '/compras/guias' : '/compras', payload);
        this.$router.push('/purchase-list');
      } catch (e) {
        const d = e.response?.data;
        this.errorRegistro = d?.details?.map(x => x.msg).join(' · ') || d?.error || e.message;
      } finally {
        this.registrando = false;
      }
    },
  },
};
</script>

<style scoped>
.beta-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  border-radius: 4px;
  vertical-align: middle;
  line-height: 1.4;
  text-transform: uppercase;
}
</style>
